<mat-sidenav-container class="full-height-container">

  @if (!detailSidenavActive) {
    <mat-sidenav #sidenav mode="side" class="sidenav-padding">

      <div class="sidenav-branding">
        <img src="/assets/img/hc-logo-toolbar.png" alt="Healthy Contracts Logo" class="brand-image">
      </div>

      @if (currentSidenavTemplate) {
        <ng-container [ngTemplateOutlet]="currentSidenavTemplate"></ng-container>
      } @else {
        <p>Healthy Contracts</p>
      }
    </mat-sidenav>
  }

  <mat-sidenav-content class="content-offset">
    <div class="fixed-header">
      <mat-toolbar color="primary" class="fixed-header">
        <mat-toolbar-row>
          <div class="align-left">
            <button mat-icon-button (click)="sidenavContentService.requestSidenavToggle(); $event.stopPropagation()">
              <mat-icon>menu</mat-icon>
            </button>
            &nbsp;
            &nbsp;
            <span>{{ titleService.title() }}</span>
          </div>
          <div class="align-right">
            @if (conciergeNavigator) {
              <button type="button" class="ask-me-btn" (click)="openConcierge()" title="Ask Me (⌘K / Ctrl-K)">
                ✨ Ask Me ✨
              </button>
              &nbsp;
              &nbsp;
            }
            <div>
              <button mat-icon-button [matMenuTriggerFor]="settings">
                <mat-icon>settings</mat-icon>
              </button>
            </div>
            &nbsp;
            &nbsp;
            <button mat-icon-button (click)="openHelpInNewTab()">
              <mat-icon>help_outline</mat-icon>
            </button>
            &nbsp;
            &nbsp;
            <button mat-icon-button [matMenuTriggerFor]="user">
              <mat-icon>person_outline</mat-icon>
            </button>
            <mat-menu #settings="matMenu">
              <button mat-menu-item [routerLink]="['/securehome/sites']">Sites</button>
              <button mat-menu-item [routerLink]="['/securehome/legal-entities']">Legal Entities</button>
              <button mat-menu-item [routerLink]="['/securehome/users']">Users</button>
              <button mat-menu-item [routerLink]="['/securehome/attachments']">Attachments</button>
              <button mat-menu-item [routerLink]="['/securehome/archived-contracts']">Archived Contracts</button>
            </mat-menu>
            <mat-menu #user="matMenu">
              <button mat-menu-item (click)="openProfileDialog()">Profile</button>
              @if (permissionsStore.isAdmin()) {
                <button mat-menu-item [routerLink]="['/securehome/permissions']">Permissions</button>
              }
              <button mat-menu-item [routerLink]="['/securehome/manage-users']">Manage Users</button>
              @if (permissionsStore.isAdmin()) {
                <button mat-menu-item [routerLink]="['/securehome/proxy-assignments']">Proxy Assignments</button>
              }
              <button mat-menu-item [routerLink]="['/logout']">Logout</button>
            </mat-menu>
            <div>
              <button mat-icon-button [matMenuTriggerFor]="apps">
                <mat-icon>apps</mat-icon>
              </button>
              <mat-menu #apps="matMenu">
                <br>
                <div class="app-menu-flex-container">
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/my-work']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>dashboard</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">My Work</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/contracts']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>verified_user</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">Contracts</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/people']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>account_circle</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">People</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/parties']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>account_balance</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">Parties</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/baas']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>insert_link</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">BAA</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/cois']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>receipt</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">COI</span>
                      </mat-card>
                    </a>
                  </div>
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/critical-dates']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>insert_invitation</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">Dates</span>
                      </mat-card>
                    </a>
                  </div>
                  @if (provisions) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/provision-list']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>notes</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Provisions</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                  @if (assessments) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/assessments']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>table_chart</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Assessments</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                  <div class="app-menu-tile">
                    <a [routerLink]="['/securehome/reports']">
                      <mat-card>
                        <mat-card-header>
                          <mat-card-title class="app-menu"><mat-icon>view_comfy</mat-icon></mat-card-title>
                        </mat-card-header>
                        <span class="app-label">Reports</span>
                      </mat-card>
                    </a>
                  </div>
                  @if (documentReviewList) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/document-review-list']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>find_replace</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Document Review</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                  @if (workflowManagement) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/workflows']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>account_tree</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Workflow</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                  @if (timesheets && timesheetsAllowed) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/timesheets']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>assignment_ind</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Timesheets</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                  @if (timecards && timecardsAllowed) {
                    <div class="app-menu-tile">
                      <a [routerLink]="['/securehome/timecards']">
                        <mat-card>
                          <mat-card-header>
                            <mat-card-title class="app-menu"><mat-icon>schedule</mat-icon></mat-card-title>
                          </mat-card-header>
                          <span class="app-label">Timecards</span>
                        </mat-card>
                      </a>
                    </div>
                  }
                </div>
              </mat-menu>
            </div>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
    </div>
    
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
    
  </mat-sidenav-content>
</mat-sidenav-container>